export default __webpack_public_path__ + "static/media/1.a497e420.png";